export const FILTERS_PANEL_OVERFLOW_MODAL_LABELS = {
	TITLE: 'Applied filters',
	CLOSE: 'Close',
	SHOW_MORE: (count: number): string => `+${count} more`,
	REMOVE_FILTER: (filterLabel: string, valueLabel: string): string =>
		`Remove filter: ${filterLabel}: ${valueLabel}`
} as const;
